import * as React from "react"
import { Box } from "@mui/material"

import { formatCompactDate } from "../../@utils"


/** The window the price is valid in. Stored as two `YYYYMMDD` integers, shown as dates. */
export default function validityColumn() {
    return {
        name: 'dateFrom', label: 'Valid',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: (value, row) => <Box display="flex" justifyContent="center">
                {`${formatCompactDate(value)} → ${formatCompactDate(row.dateTo)}`}
            </Box>
        }
    }
}
